import { Mask } from '@/utils/mask';
import React from 'react';
import { useReactToPrint } from 'react-to-print';


export const Receipt = ({ data }: any) => {
  const componentRef = React.useRef<HTMLDivElement>(null);

  const handlePrint = useReactToPrint({
    documentTitle: `Comprovante - ${data.clientName}`,
    pageStyle: `
      @page {
        size: 80mm auto;
        margin: 5mm 2mm;
      }
      @media print {
        html, body {
          height: auto !important;
          overflow: visible !important;
          background: none !important;
          font-size: 16px !important;
          color: #000000 !important;
        }
        /* Remove qualquer restrição de altura e scroll */
        * {
          max-height: none !important;
          overflow: visible !important;
        }
        .receipt-container {
          box-shadow: none !important;
          padding: 8px !important;
          width: 76mm !important;
          max-width: 76mm !important;
          height: auto !important;
          max-height: none !important;
          overflow: visible !important;
          background-size: 20px 20px !important;
          background: none !important;
          color: #000000 !important;
          page-break-inside: auto;
        }
        .no-print {
          display: none !important;
        }
        .logo-print {
          height: 50px !important;
          margin-bottom: 8px !important;
        }
        .title-print {
          font-size: 20px !important;
          margin-bottom: 4px !important;
          color: #000000 !important;
        }
        .text-print {
          font-size: 16px !important;
          line-height: 1.4 !important;
          color: #000000 !important;
        }
        .section-print {
          margin-bottom: 12px !important;
          color: #000000 !important;
          page-break-inside: avoid;
        }
        /* Seção de produtos permite quebra de página */
        .products-section-print {
          margin-bottom: 12px !important;
          color: #000000 !important;
          page-break-inside: auto !important;
        }
        .product-item-print {
          padding: 6px !important;
          margin-top: 6px !important;
          color: #000000 !important;
          background: none !important;
          page-break-inside: avoid;
          break-inside: avoid;
        }
        .payment-section-print {
          padding: 8px !important;
          color: #000000 !important;
          background: none !important;
          page-break-inside: avoid;
          break-inside: avoid;
        }
        .footer-logo-print {
          height: 40px !important;
          margin-top: 12px !important;
        }
        /* Força cor preta para todos os elementos na impressão */
        h1, h2, h3, h4, h5, h6, p, span, div {
          color: #000000 !important;
          background: transparent !important;
          border-color: #000000 !important;
        }
        /* Remove containers de scroll do Dialog */
        [role="dialog"],
        [data-radix-dialog-content],
        .DialogContent {
          max-height: none !important;
          height: auto !important;
          overflow: visible !important;
        }
      }
    `,
    contentRef: componentRef,
  });

  return (
    <div className="w-full max-w-sm mx-auto">
      <button
        onClick={() => handlePrint()}
        className="mb-4 bg-[#023859] text-white px-6 py-2 rounded-md hover:bg-[#034872] transition-colors no-print"
        type="button"
      >
        Imprimir Comprovante
      </button>

      <div
        ref={componentRef}
        className="receipt-container bg-[#FFFBEB] p-5 shadow-lg relative w-full max-w-[360px]"
        style={{
          backgroundImage: 'url("/images/receipt-bg.svg")',
          backgroundSize: '30px 30px',
          minHeight: 'auto'
        }}
      >
        <div className="flex flex-col items-center mb-4 section-print">
          <img src="/images/logo-color.png" alt="Loteria Aldeota" className="h-20 mb-2 logo-print" />
        </div>

        <div className="text-center mb-4 section-print">
          <h2 className="text-2xl font-bold uppercase text-[#023859] title-print">{data.clientName}</h2>
          <span
            className={`inline-block px-2 py-1 rounded text-base font-medium mt-2 ${
              data?.isNewClient === true
                ? "bg-green-100 text-green-700"
                : "bg-gray-100 text-gray-700"
            }`}
          >
            {data?.isNewClient === true ? "NOVO" : "ANTIGO"}
          </span>
          <p className="text-[#023859] mt-2 text-lg text-print"><span className='font-bold'>Telefone:</span> {Mask.maskPhone(data.phone)}</p>
        </div>

        <div className="mb-4 section-print">
          <p className="font-semibold text-[#023859] mb-1 text-lg text-print">VENDEDOR(A): {data.seller}</p>
          {/* {data?.clientOrigin && (
            <p className="text-[#023859] mb-1 text-base text-print">
              <span className="font-semibold">Mídia/Origem:</span> {data.clientOrigin}
            </p>
          )} */}
          {
            data?.circuit_route?.name && (
              <p className="text-[#023859] mb-1 text-base text-print">
              {data?.circuit_route?.name || "-"}
            </p>
          )}
          <p className="text-[#023859] mb-1 text-base text-print whitespace-pre-line font-bold uppercase">
            {data?.delivery_address || "-"}
          </p>
        </div>

        <div className="bg-[#F4A340] text-black py-4 px-4 rounded-lg mb-4 products-section-print">
          <h3 className="text-center text-lg font-bold title-print">
            DETALHES DA COMPRA
          </h3>
          <div className="mt-2 text-base">
            <p className="text-center text-lg text-black font-bold title-print mb-2">
              ID Venda: #{data?.id}
            </p>
            <p className="text-center text-base text-print">Produtos e valores</p>
            {data.products.map((product, index) => (
              <div key={index} className="mt-2 bg-white/20 p-3 rounded product-item-print">
                <p className="font-medium text-center text-base text-print">{product.name}</p>
                <div className="flex justify-between mt-1 text-base">
                  <span>Qtd: {product.quantity}</span>
                  <span>R$ {product?.price?.toFixed(2)}</span>
                </div>
                <div className="mt-1 text-base text-print">
                  <p>Concurso: {product.contest?.name || "-"}</p>
                  <p>Loteria: {product.contest?.lottery?.name || "-"}</p>
                  <p>Cotas: {product.product_classification?.quota_quantity || "-"}</p>
                  <p>Jogos: {product.product_classification?.game_quantity || "-"}</p>
                </div>
              </div>
            ))}
            <div className="mt-3 bg-white/30 p-3 rounded payment-section-print">
              <p className="font-medium text-center text-base text-print">Formas de Pagamento</p>
              {data.payment_forms?.map((payment, index) => (
                <div key={index} className="flex justify-between mt-1 text-base">
                  <span className="text-print">{payment.payment_form?.name}</span>
                  <span className="text-print">R$ {parseFloat(payment.value).toFixed(2)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {data.observations && (
          <div className="mb-4 section-print">
            <h3 className="font-bold mb-1 text-[#023859] text-lg text-print">OBSERVAÇÕES:</h3>
            <p className="text-[#023859] bg-white/50 p-2 rounded text-base text-print">{data.observations}</p>
          </div>
        )}

        <div className="mt-6 pt-4 section-print">
          <div className="w-full border-t border-[#023859] pt-2">
            <p className="text-center text-[#023859] font-medium text-base text-print">ASSINATURA RESPONSÁVEL</p>
          </div>
        </div>

        <div className="mt-4 flex justify-center">
          <img src="/images/rei-do-bolao.png" alt="Rei do Bolão" className="h-14 footer-logo-print" />
        </div>
      </div>
    </div>
  );
}; 